<div [formGroup]="subForm">
  <div class="mt-3">
    <!--@if ((authService.isAdmin() | async) ) {-->
    <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
      for="label"><strong>{{variables.addChangeRemoveProjectType}}.</strong></span>
    <!--}-->
    <!--@if (!((authService.isAdmin() | async) )) {-->
    <span *hasPermission="Permission.CATALOG_EDIT_CONFIG"
      [showWhen]="!canEditCatalog"><strong>{{variables.catalogRisks}}</strong></span>
    <!--}-->


    @if (listItem && listItem.length > 0) {
    <div class="list-group-control mt-3">
      <div class="d-flex list-group-control-header">
        <div class="list-group-control-header-name">{{variables.name}}</div>
        <div class="list-group-control-header-risk">{{variables.risk}} (%)</div>
      </div>
      @for (item of listItem; track item) {
      <div class="list-group-control-item">
        <div class="list-group-control-item-name">{{item.name}}</div>
        <div class="list-group-control-item-risk">{{item.risk}}</div>
        <div class="list-group-control-item-icons action_buttons" style="float: right;">
          <!--@if ((authService.isAdmin() | async) ) {-->
          <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
            matTooltip="{{variables.changeProjectType}}" (click)="openDialogEditProject(item)"
            class="icon-edit me-3 action_buttons-item">
            <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
          </span>
          <!--}-->
          <!--@if ((authService.isAdmin() | async) ) {-->
          <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
            matTooltip="{{variables.removeProjectType}}" (click)="openDialogRemove(item.name)"
            class="icon-close me-1 action_buttons-item">
            <img src="../../../../assets/svg/BinWhite.svg" alt="Bin Icon" width="15px">
          </span>
          <!--}-->
        </div>
      </div>
      }
    </div>
    }
    <br>
    @if (!listItem || listItem.length === 0) {
    <div class="mt-3"></div>
    }
    <!--@if ((authService.isAdmin() | async) ) {-->
    <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
      class="addItemsInCatalogStepBtn" (click)="openDialogProject()"
      message="{{variables.addNeweProjectType}}"></app-button>
    <!--}-->
  </div>
</div>